var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPackage2 = function SvgPackage2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.526 14.333V8.322L1.263 5.274v5.866q0 .065.032.12a.3.3 0 0 0 .098.098zm1.263 0 5.133-2.975a.3.3 0 0 0 .097-.097.24.24 0 0 0 .033-.121V5.274L7.789 8.322zM6.396 15.71.761 12.467A1.5 1.5 0 0 1 0 11.152V4.766A1.49 1.49 0 0 1 .761 3.45L6.396.207a1.5 1.5 0 0 1 1.522 0l5.636 3.244a1.5 1.5 0 0 1 .76 1.315v6.386a1.49 1.49 0 0 1-.76 1.315l-5.636 3.244a1.5 1.5 0 0 1-1.522 0m4.008-10.362 1.953-1.12-5.07-2.934a.24.24 0 0 0-.13-.04.24.24 0 0 0-.129.04L5.2 2.348zM7.157 7.234 9.115 6.1l-5.2-3.005-1.957 1.133z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPackage2);
export default ForwardRef;